/**
 * Token hashing utility for booking token resolution.
 *
 * Uses SHA-256 via the Web Crypto API (browser-native, no Node.js dependency).
 * The raw token is never stored — only its hash is matched against booking_tokens.token_hash.
 */

/**
 * Hash a raw booking token using SHA-256.
 * @param {string} rawToken - The raw token from the URL
 * @returns {Promise<string>} Hex-encoded SHA-256 hash
 */
export async function hashBookingToken(rawToken) {
  const encoder = new TextEncoder();
  const data = encoder.encode(rawToken);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
